<div class="chat-body">
    <mat-toolbar class="primary-button mat-elevation-z1">
        <div class="toolbar">
            <button mat-icon-button id="menu" (click)="tchatService.menuIsOpen = !tchatService.menuIsOpen; sidenav.toggle()">
                <mat-icon>menu</mat-icon>
            </button>
            <span class="title">T'chat</span>
        </div>
    </mat-toolbar>

    <mat-sidenav-container class="mat-sidenav-container-menu">
        <mat-sidenav #sidenav mode="side" position="start" [opened]="tchatService.menuIsOpen" [fixedInViewport]="false">
            <div class="chat-body-menu">
                <div class="chat-body-menu-item">
                    <div class="chat-body-menu-item-icon-selector">
                        <fa-icon
                            [icon]="usersIcon"
                            class="chat-body-menu-item-icon"
                            [ngClass]="{ selected: selectedMenu === MenuType.users }"
                            (click)="selectedMenu = MenuType.users"
                            matTooltip="Contacts"
                            matTooltipPosition="right"></fa-icon>
                        <fa-icon
                            [icon]="ChatRoomsIcon"
                            class="chat-body-menu-item-icon"
                            [ngClass]="{ selected: selectedMenu === MenuType.rooms }"
                            (click)="selectedMenu = MenuType.rooms"
                            matTooltip="Conversations"
                            matTooltipPosition="right"></fa-icon>
                    </div>
                    <div class="chat-body-menu-item-icon-creator">
                        <fa-icon
                            [icon]="NewChatRoomIcon"
                            class="chat-body-menu-item-icon create-icon"
                            (click)="createRoom()"
                            matTooltip="Création d'une conversation"
                            matTooltipPosition="right"></fa-icon>
                    </div>
                </div>
                <div class="chat-body-menu-content">
                    @if (selectedMenu === MenuType.users) {
                        <app-tchat-users (selectionChanged)="onUserSelected($event)"></app-tchat-users>
                    }
                    @if (selectedMenu === MenuType.rooms) {
                        <app-tchat-rooms (selectionChanged)="onRoomSelected($event)"></app-tchat-rooms>
                    }
                </div>
            </div>
        </mat-sidenav>

        <mat-sidenav-content>
            <div class="chat-body-room">
                @if (!!!currentRoom) {
                    <h1>Pas de conversation en cours</h1>
                }
                @if (!!currentRoom) {
                    <app-tchat-room [room]="currentRoom"></app-tchat-room>
                }
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
